import styled from 'styled-components';
import { colors } from '../../../../utils/utils';

export { default as Card } from './Card';
export { default as Wrapper } from './Wrapper';
export { InputField, ClearButton, InputWrapper } from './Input';
export { InfoLabel, InfoContainer, Title, InfoValue, InfoValueNoWrap, Subtitle, Separator } from './Modal';
export { default as SubmitButton } from './SubmitButton';
export { default as ErrorMessage } from './ErrorMessage';

export const FormGroup = styled.div`
    margin-bottom: 12px;

    label {
        margin-bottom: 4px;
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #354053;
    }
`;

export const SelectStyles = {
    control: (baseStyles: Record<string, string | number | boolean | null | undefined>, state: { isFocused: boolean }) => ({
        ...baseStyles,
        borderColor: state.isFocused ? 'grey' : 'transparent',
        backgroundColor: colors.white.desert_storm
    })
};
